import { OrderForm } from '~widgets/order-form';

export const CreateOrderPage = () => {
  return <OrderForm />;
};
